import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingTag from '../core/components/LoadingTag';
import { triggerLoadTimer, triggerPauseLap, triggerResetLap, triggerResetSession, triggerResumeLap, triggerStartLap, triggerStopLap } from './TimerSlice';
import { Box, Button, Grid, Stack, Typography } from '@mui/joy';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import AdjustIcon from '@mui/icons-material/Adjust';
import StopIcon from '@mui/icons-material/Stop';
import { StopCircleSharp } from '@mui/icons-material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function Timertracker() {

    const dispatch = useDispatch()
    const loading = useSelector((state) => state.timer.loading)
    const data = useSelector((state) => state.timer.data)
    const session = useSelector((state) => state.timer.session)
    const lap = useSelector((state) => state.timer.lap)
    const saving = useSelector((state) => state.timer.saving)
    const now = useSelector((state) => state.timer.now)

    const startSession = () => {
        dispatch(triggerResetSession())
    }

    const startLap = () => {
        dispatch(triggerStartLap())
    }

    const pauseLap = () => {
        dispatch(triggerPauseLap())
    }

    const resumeLap = () => {
        dispatch(triggerResumeLap())
    }

    const stopLap = () => {
        dispatch(triggerStopLap())
    }

    const resetLap = () => {
        dispatch(triggerResetLap())
    }

    React.useEffect(() => {
        dispatch(triggerLoadTimer())
    }, []);

    if (loading)
        return <LoadingTag loading={loading} />

    return <Grid xs={12} sx={{ padding: "10px" }}>
        <Stack direction={"row"} spacing={2}

            sx={{
                display: "flex",
                verticalAlign: "center",
                justifyContent: "left",
                alignItems: "center"
            }}
        >
            <Box sx={{ fontSize: "18px" }}>
                <b>Hoje:</b> {data.dia}/{data.mes}/{data.ano} {data.nome} - {data.horario}
            </Box>
            <Box sx={{ fontSize: "18px" }}>
                <b>Sessão:</b> {session == null ? "00:00:00" : session.label}
            </Box>
            <Stack direction={"row"} spacing={1}>

                {session === null &&
                    <Button size='sm' onClick={() => startSession()} color="danger">
                        <PlayArrowIcon />
                    </Button>}
                {session !== null &&
                    <Button size='sm' onClick={() => startSession()} color="danger">
                        <RestartAltIcon />
                    </Button>}
            </Stack>
            <Box sx={{ fontSize: "18px" }}>
                <b>Lap:</b> {lap === null ? "00:00:00" : lap.label}
            </Box>
            <Stack direction={"row"} spacing={1}>
                {lap === null &&
                    <Button size='sm' onClick={() => startLap()} color="primary">
                        <PlayArrowIcon />
                    </Button>}

                {lap !== null && lap.paused != false &&
                    <Button size='sm' onClick={() => resumeLap()} color="primary">
                        <PlayArrowIcon />
                    </Button>}
                {lap != null && lap.paused === false &&
                    <Button size='sm' onClick={() => pauseLap()} color="primary">
                        <PauseIcon />
                    </Button>}
                {lap != null &&
                    <Button size='sm' onClick={() => stopLap()} color="danger">
                        <StopIcon />
                    </Button>}
                {lap != null &&
                    <Button size='sm' onClick={() => resetLap()} color="danger">
                        <RestartAltIcon />
                    </Button>}
            </Stack>
            {saving === true && <LoadingTag text="Salvando..." />}
            {/* {saving === false && <CheckCircleOutlineIcon style={{color: "green"}}/>} */}
        </Stack>
    </Grid>
}

export default Timertracker